import React, { useEffect, useState } from "react";
import "../style/About.css";
import "../style/Common.css";
import aboutUs from "../images/More.jpg";
import "../style/More.css";
import img1 from "../images/blog-01.jpg";
import img2 from "../images/blog-02.jpg";
import img5 from "../images/blog-05.jpg";
import styles from "../style/Blog.module.css";
import { Link } from "react-router-dom";

const getFirstSentence = (text) => {
  const match = text.match(/[^.!?]*[.!?]/);
  return match ? match[0] : text; // Return the first sentence if it matches, otherwise return the full text
};

const Blog = () => {
  //   const blogs = [
  //     {
  //       id: 1,
  //       title: "Tips for Batching Your Social Media Schedule",
  //       date: "November 25, 2020",
  //       author: "Admin",
  //       image: img1,
  //     },
  //     {
  //       id: 2,
  //       title: "Tasty and Timeless: Recipes to be Thankful For",
  //       date: "November 25, 2020",
  //       author: "Admin",
  //       image: img2,
  //     },
  //     {
  //       id: 3,
  //       title: "Issuu for Students and Recent Graduates",
  //       date: "November 25, 2020",
  //       author: "Admin",
  //       image: img3,
  //     },
  //     {
  //       id: 4,
  //       title: "5 Tools to Help with Instagram Growth",
  //       date: "November 25, 2020",
  //       author: "Admin",
  //       image: img4,
  //     },
  //     {
  //       id: 5,
  //       title: "How to Use Stories to Drive Sales",
  //       date: "November 25, 2020",
  //       author: "Admin",
  //       image: img5,
  //     },
  //     {
  //       id: 6,
  //       title: "Issuu for Students and Recent Graduates Copy",
  //       date: "March 10, 2023",
  //       author: "Admin",
  //       image: img1,
  //     },
  //   ];

  const imageMap = {
    1: img1,
    2: img2,
    // 3: img3,
    // 4: img4,
    5: img5,
  };
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    const fetchBlogs = async () => {
      await fetch("https://book.swlancer.com/node/get_blogs")
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              "Network response was not ok " + response.statusText
            );
          }
          return response.json();
        })
        .then((data) => {
          console.log(data);
          setBlogs(data);
          setLoading(false);
        })
        .catch((error) => {
          setError(error.message);
          console.error(
            "There was a problem with your fetch operation:",
            error
          );
        });
    };

    fetchBlogs();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <section className="more" id="more">
      <div className="about-us-container">
        <div className="about-us-content">
          <h1>Blogs</h1>
          <nav className="breadcrumb">
            <span>Home</span>
            <span className="separator">|</span>
            <span>Blogs</span>
          </nav>
        </div>
        <div className="about-us-image">
          <img src={aboutUs} alt="About Us" />
        </div>
      </div>
      <div className={styles.container}>
        <h2 className={styles.title}>Our Latest Blogs</h2>
        <div className={styles.grid}>
          {currentBlogs.map((blog) => (
            <Link
              to={`/blog/${blog.blog_id}`}
              state={{ blog }}
              style={{
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <img
                src={imageMap[blog.blog_id] || img1}
                alt={blog.title}
                className={styles.image}
              />
              <div className={styles.content}>
                <p className={styles.meta}>
                  <span>{blog.staff}</span>
                  {`\u00A0\u00A0\u00A0`}
                  <span>{new Date(blog.date).toDateString()}</span>
                </p>
                <h3 className={styles.blogTitle}>{blog.title}</h3>
                <p className={styles.blogDescription}>
                  {getFirstSentence(blog.details.description)}
                </p>
              </div>
            </Link>
          ))}
        </div>
        <Pagination
          blogsPerPage={blogsPerPage}
          totalBlogs={blogs.length}
          paginate={paginate}
        />
      </div>
    </section>
  );
};

export default Blog;

const Pagination = ({ blogsPerPage, totalBlogs, paginate }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalBlogs / blogsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav className={styles.pagination}>
      <ul className={styles.paginationList}>
        {pageNumbers.map((number) => (
          <li key={number} className={styles.pageItem}>
            <button
              onClick={() => paginate(number)}
              className={styles.pageLink}
            >
              {number}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};
